module.exports = __webpack_public_path__ + "static/media/ipad-820272_1920_mod_neg.69d937a6.jpg";